app.service('CurrentReferral', [ 'IMPACT_ON_LIFE_VALID_MONTHS', function(IMPACT_ON_LIFE_VALID_MONTHS) {

	var service = {

		referral: {},

		setReferral: function(referral) {
			service.referral = referral;
		},

		clearReferral: function() {
			service.referral = {};
		},

		/**
		 * When the impact-on-life answers on this referral were recorded, or null when
		 * there are none and when the API sent no timestamp with them - callers have to
		 * cope with having no date rather than rendering an empty one.
		 */
		impactOnLifeDate: function() {
			var impactOnLife = service.referral && service.referral.cpacImpactOnLife;
			if (!impactOnLife) {
				return null;
			}
			return impactOnLife.timeLastUpdated || impactOnLife.timeCreated || null;
		},

		/**
		 * Whether the impact-on-life questions have been answered against this referral
		 * at all. Truthiness, not a null check - the referral carries no cpacImpactOnLife
		 * property until they have been answered once.
		 */
		hasImpactOnLife: function() {
			return !!(service.referral && service.referral.cpacImpactOnLife);
		},

		/**
		 * Whether the answers this referral carries are now too old to score against.
		 *
		 * Answers we can't date are left alone: without a timestamp there is nothing to
		 * measure, and discarding a set that may well be current would make the user
		 * answer the questionnaire again for no reason.
		 */
		isImpactOnLifeExpired: function() {
			var answeredOn = service.impactOnLifeDate();
			if (!answeredOn) {
				return false;
			}

			var answeredDate = new Date(answeredOn);
			if (isNaN(answeredDate.getTime())) {
				return false;
			}

			var expiresOn = new Date(answeredDate.getTime());
			expiresOn.setMonth(expiresOn.getMonth() + IMPACT_ON_LIFE_VALID_MONTHS);
			return expiresOn.getTime() < Date.now();
		},

		/**
		 * Whether the referral can be scored publicly as it stands: the questions have
		 * been answered and the answers are still current. Expired answers behave exactly
		 * like no answers at all, which routes the user back into the questionnaire for a
		 * new set.
		 */
		hasCurrentImpactOnLife: function() {
			return service.hasImpactOnLife() && !service.isImpactOnLifeExpired();
		},

	};

	return service;
}])
